export default __webpack_public_path__ + "static/media/coursimg.133c97ab.jpg";